"use strict";

exports.__esModule = true;
exports.PredefinedCommentsRoutes = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _CheckAccessRoute = require("../../Core/CheckAccessRoute");
var _System = require("../../../System");
var _PredefinedCommentsScreen = require("../PredefinedCommentsScreen");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PredefinedCommentsRoutes = exports.PredefinedCommentsRoutes = function PredefinedCommentsRoutes() {
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("PredefinedComments"),
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: ["PLANT_SETTINGS"],
      component: _PredefinedCommentsScreen.PredefinedCommentsScreen
    })
  }));
};